import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetPassword } from "../api";

import useValidations from "../../../utils/hooks/useValidations";
import { toast } from "react-toastify";

const useResetPassword = (emailRef) => {
  const { validPasswords } = useValidations();
  const navigate = useNavigate();

  const [resetStatus, setResetStatus] = useState("idle");

  useEffect(() => {
    if (resetStatus === "success") {
      navigate("/login");
    } else if (resetStatus === "failed") {
      formik.setFieldError("confirm_password", "An error occured");
    }
    // eslint-disable-next-line
  }, [resetStatus]);

  const formik = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validate: (values) => {
      let errors = {};
      const {
        uppercasePassword,
        lowercasePassword,
        digitsPassword,
        minLengthPassword,
        charsPassword,
      } = validPasswords(values.password);
      if (!values.password) { 
        errors.password = "*Password required";
      }
      if (!values.confirm_password) {
        errors.confirm_password = "*Password confirmation required";
      }
      if (values.password !== values.confirm_password) {
        errors.confirm_password = "*Passwords does not match";
      }
      if (!minLengthPassword) {
        errors.password = "*Password should be atleast 8 digits";
      }
      if (!charsPassword) {
        errors.password = "*Enter atleast 1 special character";
      }
      if (!digitsPassword) {
        errors.password = "*Enter atleast 1 digit";
      }
      if (!lowercasePassword) {
        errors.password = "*Enter atleast 1 lowercase letter";
      }

      if (!uppercasePassword) {
        errors.password = "*Enter atleast 1 uppercase letter";
      }

      return errors;
    },
    onSubmit: (values) => {
      setResetStatus("pending");

      resetPassword(values, emailRef.current).then((response) => {
        if (
          response?.status === 200 &&
          localStorage.getItem("USER_ACCESS_TOKEN")
        ) {
          setResetStatus("success");
          toast.success("Password Changed")
        } else {
          setResetStatus("failed");
        }
      });
    },
  });
  return {
    formik,
    resetStatus,
  };
};

export default useResetPassword;
